<template>
  <div class="solutionCase">
    <top-nav></top-nav>
    <div class="solutionCaseBanner">
        <div class="solutionCaseBannerIn">平安城市解决方案</div>
    </div>
    <section class="solutionConcept">
      <div class="solutionCaseBox" style="padding-bottom: 0">
        <div class="solutionConceptBox">
          <div class="solutionConceptBoxR">
            <img src="../../../static/images/solutionConceptPic3.jpg" />
          </div>
          <div class="solutionConceptBoxL">
            <div class="solutionConceptIn">
              <div class="solutionConceptInTit">项目概念</div>
              <div class="solutionConceptInConn">
                利用IPv6海量地址的特征实现全网安全监控摄像头统一编址，解决多个监控网络无法互通的问题，实现在原有IPv4监控平台访问、管理、存储IPv6摄像头及视频的功能。
              </div>
            </div>
            <div class="solutionConceptArr"></div>
          </div>
        </div>
      </div>
    </section>
    <section class="solutionIncome">
      <div class="solutionCaseBox">
        <div class="solutionCaseTit">客户收益</div>
        <ul class="solutionIncomeFlex">
          <li>
            <img src="../../../static/images/solutionDetailIcon03.png" />
            <div class="solutionIncomeConn">区域人群的定向监控</div>
          </li>
          <li>
            <img src="../../../static/images/solutionDetailIcon08.png" />
            <div class="solutionIncomeConn">交通工具的监控分析</div>
          </li>
          <li>
            <img src="../../../static/images/solutionDetailIcon04.png" />
            <div class="solutionIncomeConn">突发事件的全天候监控</div>
          </li>
        </ul>
      </div>
    </section>
    <section class="solutionAdvantage">
      <div class="solutionAdvantageBox">
        <div class="solutionAdvantageTit">项目优势</div>
        <img src="../../../static/images/solutionAdvantageIcon03.png" />
        <div class="solutionAdvantageConn" style="left: 170px; top: 150px">
          <div class="solutionAdvantageConnBox">
            提高安防网络的数字化、网络化、大型化和智能化水平
          </div>
        </div>
        <div class="solutionAdvantageConn" style="right: 170px; top: 150px">
          <div class="solutionAdvantageConnBox">
            凸显经济实用性，有利于联网集成，便于施工、维护和降低成本
          </div>
        </div>
        <div class="solutionAdvantageConn" style="left: 170px; top: 304px">
          <div class="solutionAdvantageConnBox">
            提供清晰、简介、友好的中文操作界面，操控简便、灵活，易学易用，便于管理和维护
          </div>
        </div>
        <div class="solutionAdvantageConn" style="right: 170px; top: 304px">
          <div class="solutionAdvantageConnBox">
            海量的IPv6地址，结合网络发展的要求，有较大的扩充空间
          </div>
        </div>
      </div>
    </section>
    <section class="solutionValue">
      <div class="solutionCaseBox">
        <div class="solutionCaseTit">项目价值</div>
        <ul class="solutionIncomeFlex">
          <li>
            <img src="../../../static/images/solutionValuePic01.png" />
            <div class="solutionIncomeConn">
              扩容现有平安城市管理<br />平台，完善网络系统建设
            </div>
          </li>
          <li>
            <img src="../../../static/images/solutionValuePic02.png" />
            <div class="solutionIncomeConn">
              加大治安视频监控覆盖<br />面，继续整合社会监控资源
            </div>
          </li>
          <li>
            <img src="../../../static/images/solutionValuePic03.png" />
            <div class="solutionIncomeConn">
              完善“平台管理、联网运行、<br />资源整合、信息共享”的运行机制
            </div>
          </li>
          <li>
            <img src="../../../static/images/solutionValuePic04.png" />
            <div class="solutionIncomeConn">
              构建以科技为基础<br />的社会综合防控体系
            </div>
          </li>
        </ul>
      </div>
    </section>
    <bottom-footer></bottom-footer>
  </div>
</template>

<script>
import topNav from "@/components/topNav";
import bottomFooter from "@/components/bottomFooter.vue";
import banner from "@/components/banner.vue";

export default {
  name: "solutionCase",
  data() {
    return {
        bgImage:'../../../static/images/solutionCaseBanner2.jpg?011901',
      showMask: false,
    };
  },

  components: {
    topNav,
    bottomFooter,
    banner,
  },

  computed: {},

  mounted() {},

  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../../assets/css/global";
@import "./solution";
.solutionCase {
    .solutionCaseBanner{
         background:url(../../../static/images/solutionCaseBanner2.jpg?011902) no-repeat center;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/solution/solutionCase2.vue